/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkillTranslation
 */
export interface SkillTranslation {
    /**
     * 
     * @type {string}
     * @memberof SkillTranslation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SkillTranslation
     */
    name?: string;
}

/**
 * Check if a given object implements the SkillTranslation interface.
 */
export function instanceOfSkillTranslation(value: object): value is SkillTranslation {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function SkillTranslationFromJSON(json: any): SkillTranslation {
    return SkillTranslationFromJSONTyped(json, false);
}

export function SkillTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function SkillTranslationToJSON(value?: SkillTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

